import ng from 'angular';
import { CommonsModalService } from 'ib-web-commons/dist/app/core/ib-modal/services/ib-modal-service';
import { AttendanceVoucher } from './model/model';

@Component(
    'ib-pmt-assistance-voucher-info-module',
    'ibPmtAssistanceVoucherInfo',
    {
        controllerAs: 'assistanceVoucherCtrl',
        bindings: {
            attendanceVouchers: '='
        },
        templateUrl: ['$rootScope', function ($rootScope) {
            return $rootScope.routes.templates + 'ib-pmt-assistance-voucher-info-view.html';
        }]
    },
    ['$scope', 'CommonsModalService'],
    []
)

export class ibPmtAssistanceVoucherInfo implements ng.IController{
    public attendanceVouchers: AttendanceVoucher[];
    constructor (
        private $scope: ng.IScope,
        private commonsModalService: CommonsModalService
    ) {
    }

    $onInit () {
        this.$scope.$on('sendAttendanceVoucherByEmail', () => this.openModal());
    }

    openModal () {
        const modelObject = {};
        this.commonsModalService.showGenericDynamicModal(
            false,
            'ib-modal-assistance-voucher-email-view.html',
            modelObject,
            'ibModalAssistanceVoucherEmailController',
            'ib-modals ib-modals--right fade'
        );
    }
}